import { useState } from 'react';
import SafetyBanner from './SafetyBanner';
import EmptyState from './EmptyState';
import ActiveChat from './ActiveChat';

/**
 * Centre column: the flexible middle of the three-column shell.
 *
 * The banner is intentionally rendered in both states - the reminder applies
 * while chatting just as much as before you start, and keeping it mounted avoids
 * a layout jump on selection.
 *
 * `motionPaused` freezes the decorative mascot while the welcome modal is up.
 */
export default function ChatArea({
  currentUser,
  conversation,
  messages,
  threadStatus,
  threadError,
  sending,
  sendProgress,
  hasMore,
  onLoadOlder,
  onSendMessage,
  onClearSelection,
  isFavorite,
  onToggleFavorite,
  profile,
  onOpenDetails,
  motionPaused = false,
  partnerTyping = false,
  onTyping,
}) {
  const [bannerDismissed, setBannerDismissed] = useState(false);

  return (
    // `pt-[env(safe-area-inset-top)]` lives here rather than on the header so
    // the notch strip is covered whether or not the safety banner is showing.
    <main className="flex h-full min-w-0 flex-1 flex-col overflow-hidden bg-canvas pt-[env(safe-area-inset-top)]">
      {!bannerDismissed && (
        <div className="shrink-0 px-3 pt-2.5 sm:px-5 sm:pt-4">
          <SafetyBanner onDismiss={() => setBannerDismissed(true)} />
        </div>
      )}

      {conversation ? (
        <ActiveChat
          key={conversation.id}
          conversation={conversation}
          currentUser={currentUser}
          profile={profile}
          messages={messages}
          threadStatus={threadStatus}
          threadError={threadError}
          sending={sending}
          sendProgress={sendProgress}
          hasMore={hasMore}
          onLoadOlder={onLoadOlder}
          onSendMessage={onSendMessage}
          onBack={onClearSelection}
          isFavorite={isFavorite}
          onToggleFavorite={onToggleFavorite}
          onOpenDetails={onOpenDetails}
          partnerTyping={partnerTyping}
          onTyping={onTyping}
        />
      ) : (
        <div className="z2-scroll min-h-0 flex-1 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center px-5 py-8">
            <EmptyState motionPaused={motionPaused} />
          </div>
        </div>
      )}
    </main>
  );
}
